import { createSelector } from 'reselect';

import { PlacementsMapHelpers } from '../../service/PlacementsMap/PlacementsMap';
import { CampaignType } from '../../typings/domain';
import { State } from '../../typings/state';
import { selectEditGroupValueInfo } from '../groupEdit/group/group';

export const selectGroupOutdoorValue = createSelector(
    (state: State) => state.commonData.outdoorMapData,
    (state: State, groupId: string) => {
        const groupValue = selectEditGroupValueInfo(state, groupId);

        switch (groupValue.campaignType) {
            case CampaignType.CPM_BANNER:
                return groupValue.outdoorMap;
            default:
                return undefined;
        }
    },
    (outdoorMapData, groupOutdoorMap) => {
        if (!outdoorMapData || !groupOutdoorMap) {
            throw Error('Нет данных для outdoor карты');
        }

        return {
            checkedByRegion: PlacementsMapHelpers.getOutdoorCheckedByRegion(
                outdoorMapData.screenGroupsByRegion,
                groupOutdoorMap.pageBlocks
            )
        };
    }
);

export const selectGroupIndoorValue = createSelector(
    (state: State) => state.commonData.indoorMapData,
    (state: State, groupId: string) => {
        const groupValue = selectEditGroupValueInfo(state, groupId);

        switch (groupValue.campaignType) {
            case CampaignType.CPM_BANNER:
                return groupValue.indoorMap;
            default:
                return undefined;
        }
    },
    (indoorMapData, groupIndoorMap) => {
        if (!indoorMapData || !groupIndoorMap) {
            throw Error('Нет данных для outdoor карты');
        }

        return {
            checkedByRegion: PlacementsMapHelpers.getIndoorCheckedByRegion(
                indoorMapData.screenGroupsByRegion,
                groupIndoorMap.pageBlocks
            )
        };
    }
);

export const filterGroupIndoorMapData = createSelector(
    (state: State) => state.commonData.indoorMapData,
    (state: State, groupId: string) => {
        const groupValue = selectEditGroupValueInfo(state, groupId);

        switch (groupValue.campaignType) {
            case CampaignType.CPM_BANNER:
                return groupValue.indoorMap;
            default:
                return undefined;
        }
    },
    (indoorMapData, groupIndoorMap) => {
        if (!indoorMapData || !groupIndoorMap) {
            throw Error('Нет данных для outdoor карты');
        }

        const screenGroupsByRegion = PlacementsMapHelpers.filterDeletedPlacements(
            indoorMapData.screenGroupsByRegion,
            groupIndoorMap.pageBlocks
        );

        const regions = PlacementsMapHelpers.filterDeletedRegions(
            indoorMapData.regions,
            Object.keys(screenGroupsByRegion)
        );

        return {
            ...indoorMapData,
            regions,
            screenGroupsByRegion
        };
    }
);

export const filterGroupOutdoorMapData = createSelector(
    (state: State) => state.commonData.outdoorMapData,
    (state: State, groupId: string) => {
        const groupValue = selectEditGroupValueInfo(state, groupId);

        switch (groupValue.campaignType) {
            case CampaignType.CPM_BANNER:
                return groupValue.outdoorMap;
            default:
                return undefined;
        }
    },
    (outdoorMapData, groupOutdoorMap) => {
        if (!outdoorMapData || !groupOutdoorMap) {
            throw Error('Нет данных для outdoor карты');
        }

        const screenGroupsByRegion = PlacementsMapHelpers.filterDeletedPlacements(
            outdoorMapData.screenGroupsByRegion,
            groupOutdoorMap.pageBlocks
        );

        const regions = PlacementsMapHelpers.filterDeletedRegions(
            outdoorMapData.regions,
            Object.keys(screenGroupsByRegion)
        );

        return {
            ...outdoorMapData,
            regions,
            screenGroupsByRegion
        };
    }
);
